<template>
  <SFHeadline :tag="`h${level}`" size="xl" is-uppercase class="my-4">
    <slot />
  </SFHeadline>
</template>

<script setup lang="ts">
import type { Block } from '@contentful/rich-text-types'
import { SFHeadline } from '#storefront-ui/components'

defineProps<{ level: number; node: Block }>()

defineOptions({
  name: 'CMSHeadingNode',
})
</script>
